import { useState, useRef } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { ContentLayout, HeaderBreadcrumbs, TabPanel } from "../../../shared";
import { Security, ProfileData } from "../components";
import { useProfile } from "..";
import SimpleReactValidator from "simple-react-validator";
import { TabContextProvider } from "../../../store";


export function ProfileDetails() {
  const [value, setValue] = useState("1");
  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const {
    countryCodes,
    state,
    isStoreAdmin,
    onEdit,
    onUpdateProfile,
    onCancel,
    onChange,
    onDropdown,
    handleDropdown,
    currentTab,
    setCurentTab,
  } = useProfile({
    isProfile: true,
  });

  const handleChange = (event, newValue) => {
    setCurentTab("profile", newValue);
  };
  return (
    <>
      <ContentLayout
        title="Profile"
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: isStoreAdmin ? "/store-admin/" : "/" },
              { name: "Profile" }
            ]}
          />
        }
      >
          <Box className="sticky-Tab" sx={{ borderBottom: 1, borderColor: "divider", top: "104px" }}>
            <Tabs value={currentTab} onChange={handleChange}>
              <Tab label="General" value="1" />
              <Tab label="Security" value="2" />
            </Tabs>
          </Box>
        <TabContextProvider value={currentTab}>
          <TabPanel sx={{ px: "0" }} value="1">
            <ProfileData
              isBusy={state.profileDetails.isBusy}
              state={state}
              onChange={onChange}
              onDropdown={onDropdown}
              handleDropdown={handleDropdown}
              validator={validator}
              setValue={setValue}
              onEdit={onEdit}
              onUpdateProfile={onUpdateProfile}
              forceUpdate={forceUpdate}
              countryCodes={countryCodes}
            />
          </TabPanel>
          <TabPanel sx={{ px: "0" }} value="2">
            <Security state={state} />
          </TabPanel>
        </TabContextProvider>
      </ContentLayout>
    </>
  );
}
